import { EnhancedTable, TableCellRoute } from "@relode/core";
import * as React from "react";

import { MemberUpcomingInterview } from "../_infra/types";
import { UpcomingInterviewDateColumn } from "./upcomingInterviewDateColumn";

export const UpcomingInterviewsDesktop = (props: {
    data: MemberUpcomingInterview[];
}) => {
    const { data } = props;

    if (!data) return null;

    return (
        <EnhancedTable
            data={data}
            options={{
                hideCheckbox: true,
            }}
            columns={[
                {
                    title: "candidate name",
                    field: "candidateName",
                    columnSize: "large",
                    render: (data: MemberUpcomingInterview) => (
                        <TableCellRoute
                            title={data.candidateName}
                            pathname={`/candidates/${data.jobId}/${data.leadId}`}
                        >
                            {data.candidateName}
                        </TableCellRoute>
                    ),
                },
                {
                    title: "job title",
                    field: "jobName",
                    columnSize: "large",
                },
                {
                    title: "location",
                    field: "location",
                    columnSize: "large",
                },
                {
                    title: "organization",
                    field: "organization",
                    columnSize: "large",
                },
                {
                    title: "date and time",
                    field: "interviewDate",
                    columnSize: "large",
                    render: (data: MemberUpcomingInterview) => (
                        <UpcomingInterviewDateColumn data={data} />
                    ),
                },
            ]}
            dataCy={"upcomingInterviewsDesktop"}
        />
    );
};
